import type { CardsInRow } from 'containers/RowContainer'

import { useMemo } from 'react'
import { useClientGridWidth } from './useClientGridWidth'
import { useCurrentCard } from './useCurrentCard'

export const useGridCardsCount = (
  cardsInRow: CardsInRow,
  tvChannelCard: boolean
): number => {
  const rowDirection = useMemo(() => cardsInRow?.charAt(0), [cardsInRow])
  const clientWidth = useClientGridWidth()

  return useCurrentCard({
    cardsInRow: +cardsInRow.split('_')[1],
    rowDirection,
    clientWidth,
    tvChannelCard,
  })
}
